import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid"; // heroicons for success icon
import { useNavigate } from "react-router-dom";

const LoanSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-6">
            {/* Success Icon */}
            <CheckCircleIcon className="w-20 h-20 text-green-500 mb-6" />

            {/* Success Message */}
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
                Loan Booked Successfully!
            </h1>
            <p className="text-gray-500 text-center max-w-sm mb-6">
                Congratulations 🎉 Your loan application has been successfully booked.
                You can now view the details of your loans anytime.
            </p>

            {/* Action Button */}
            <button
                onClick={() => navigate("/loan-center")}
                className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md transition-all duration-200 font-medium"
            >
                View Your Loans
            </button>
        </div>
    );
};

export default LoanSuccess;
